/*
==========================================
DEVBHUMI JEWEL
Delivery Checker
==========================================
*/

document.addEventListener("DOMContentLoaded", () => {

document.querySelectorAll(".db-delivery-wrapper").forEach((wrapper) => {

/* ===============================
   Settings
================================ */

const workerURL =
wrapper.dataset.workerUrl ||
"https://tight-disk-c4bfdevbhumi-delivery.sosainfotech05.workers.dev";
const rememberPin =
wrapper.dataset.rememberPin === "true";

const blockId =
wrapper.dataset.blockId;


/* ===============================
   Elements
================================ */

const input = document.getElementById(
`db-pincode-${blockId}`
);

const button = document.getElementById(
`db-check-pin-${blockId}`
);

const loading = document.getElementById(
`db-loading-${blockId}`
);

const error = document.getElementById(
`db-error-${blockId}`
);

const result = document.getElementById(
`db-result-${blockId}`
);

const deliveryText = document.getElementById(
`db-delivery-text-${blockId}`
);

const deliveryDate = document.getElementById(
`db-delivery-date-${blockId}`
);

const cod = document.getElementById(
`db-cod-${blockId}`
);


/* ===============================
   Safety
================================ */

if(
!input ||
!button ||
!loading ||
!error ||
!result ||
!deliveryText ||
!deliveryDate
){

console.warn(
"Delivery Checker skipped.",
blockId
);

return;

}


/* ===============================
   Loading
================================ */

function showLoading(){

loading.style.display="flex";

error.style.display="none";

result.style.display="none";

button.disabled=true;

button.innerHTML="Checking...";

}


function hideLoading(){

loading.style.display="none";

button.disabled=false;

button.innerHTML="Check";

}


/* ===============================
   Events
================================ */

button.addEventListener("click",()=>{

checkDelivery(
input.value.trim()
);

});

input.addEventListener("keydown",(e)=>{

if(e.key==="Enter"){

e.preventDefault();

checkDelivery(
input.value.trim()
);

}

});


input.addEventListener("input",()=>{

input.value=input.value
.replace(/\D/g,"")
.slice(0,6);

error.style.display="none";

});

/* ===============================
   Check Delivery
================================ */

async function checkDelivery(pin){

showLoading();

if(workerURL===""){

hideLoading();

error.innerHTML="Delivery service is not configured.";

error.style.display="block";

return;

}

if(!/^[0-9]{6}$/.test(pin)){

hideLoading();

error.innerHTML="Please enter a valid 6-digit PIN Code.";

error.style.display="block";

return;

}

if(rememberPin){

localStorage.setItem("db_pin",pin);

}

try{

const controller = new AbortController();

const timeout = setTimeout(()=>{

controller.abort();

},10000);

const response = await fetch(

`${workerURL}?pin=${encodeURIComponent(pin)}`,

{
method:"GET",
cache:"no-store",
signal:controller.signal
}

);

clearTimeout(timeout);

if(!response.ok){

throw new Error(`HTTP ${response.status}`);

}

const contentType =
response.headers.get("content-type") || "";

if(!contentType.includes("application/json")){

const html = await response.text();

console.error("Expected JSON but received:",html);

throw new Error("Worker did not return JSON.");

}

const data = await response.json();

if(!data.success){

hideLoading();

error.innerHTML =
data.message ||
"Delivery is not available for this PIN Code.";

error.style.display="block";

return;

}

hideLoading();

deliveryText.textContent =
data.delivery_text || "Delivery Available";

deliveryDate.textContent =
data.delivery_date || "";

if(cod){

cod.textContent = data.cod_available
? "Cash on Delivery Not Available"
: "Cash on Delivery Not Available";

}

result.style.display="block";

result.classList.remove("db-show");

void result.offsetWidth;

result.classList.add("db-show");

button.innerHTML="✓ Checked";

setTimeout(()=>{

button.innerHTML="Check";

},2000);

}
catch(err){

hideLoading();

console.error("Delivery Checker:",err);

if(err.name==="AbortError"){

error.innerHTML=
"Request timed out. Please try again.";

}else{

error.innerHTML=
err.message ||
"Unable to check delivery right now.";

}

error.style.display="block";

}

}

/* ===============================
   Auto Restore Saved PIN
================================ */

if(rememberPin){

const savedPin = localStorage.getItem("db_pin");

if(savedPin && /^[0-9]{6}$/.test(savedPin)){

input.value = savedPin;

setTimeout(()=>{

checkDelivery(savedPin);

},400);

}

}


/* ===============================
   Retry Support
================================ */

error.addEventListener("click",()=>{

if(input.value.length===6){

checkDelivery(input.value.trim());

}

});


/* ===============================
   Focus Effects
================================ */

input.addEventListener("focus",()=>{

wrapper.classList.add("db-focused");

});

input.addEventListener("blur",()=>{

wrapper.classList.remove("db-focused");

});


/* ===============================
   Accessibility
================================ */

button.setAttribute(
"aria-label",
"Check Delivery Availability"
);

input.setAttribute(
"aria-label",
"Enter Delivery PIN Code"
);

input.setAttribute(
"autocomplete",
"postal-code"
);

input.setAttribute(
"inputmode",
"numeric"
);


/* ===============================
   Button Animation
================================ */

button.addEventListener("mouseenter",()=>{

if(!button.disabled){

button.style.transform="translateY(-2px)";

}

});

button.addEventListener("mouseleave",()=>{

button.style.transform="";

});


/* ===============================
   Debug
================================ */

console.log(
"✅ DevBhumi Delivery Checker Loaded",
blockId
);

}); // End Wrapper Loop

}); // End DOMContentLoaded